var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1PeopleResearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.13 66.51L49.74 48.58a23.08 23.08 0 10-5.2 3l11.53 18.15a3.002 3.002 0 004.185.992 2.999 2.999 0 00.875-4.212zM35.64 48.88A18.76 18.76 0 1154.4 30.12a18.79 18.79 0 01-18.76 18.76zM46 36v4H24v-4a5 5 0 015-5h12a5 5 0 015 5zM31.29 25.51a5.24 5.24 0 117.37.83 5.25 5.25 0 01-7.37-.83z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_People_research.04c63ab3.svg";
export { SvgK1PeopleResearch as ReactComponent };